import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import NewsletterFormComponent from '@fuww/library/src/NewsletterForm';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import messages from '../../lib/messages.json';
import getEmailSuggestionFormatter from '../../lib/getEmailSuggestionFormatter';
import showNewsletterSignup from '../../lib/showNewsletterSignup';

const newsletterFormPropertyTypes = {
  showDescriptiveText: PropTypes.bool,
};

type NewsletterFormProperties = InferProps<
  typeof newsletterFormPropertyTypes
>;

const NewsletterForm = (
  { showDescriptiveText } : NewsletterFormProperties,
) => {
  const intl = useIntl();
  const { route } = useRouter();

  return route === '/newsletter'
  || (route !== '/news-form' && showNewsletterSignup()) ? (
    <NewsletterFormComponent
    // eslint-disable-next-line max-len
      url={`//fashionunited.us3.list-manage.com/subscribe/post?u=f9c546df23ea10a6fc72d2f2a&id=${intl.formatMessage(messages[
        'newsletterForm.mailChimpListId'
      ])}`}
      title={intl.formatMessage(messages['newsletterForm.title'])}
      description={(
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage(
              messages['newsletterForm.description'],
            ),
          }}
        />
      )}
      emailValidationMessage={intl.formatMessage(messages[
        'applicantForm.mustBeValidEmailAddress'
      ])}
      requiredValidationMessage={intl.formatMessage(messages[
        'applicantForm.fieldRequired'
      ])}
      emailAddressLabel={intl.formatMessage(messages.emailAddress)}
      formatEmailSuggestion={getEmailSuggestionFormatter(intl)}
      disclaimerMessage={(
        <small
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage(
              messages['newsletterForm.disclaimerMessage'],
            ),
          }}
        />
      )}
      submitLabel={intl.formatMessage(messages[
        'newsletterForm.submitLabel'
      ])}
      showDescriptiveText={showDescriptiveText}
    />
    ) : null;
};

NewsletterForm.propTypes = newsletterFormPropertyTypes;

export default NewsletterForm;
